import { useSelector } from "react-redux";
import Error401 from "../../assets/images/errors/error401.png";
import Navbar from "../../components/navigation/Navbar";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ErrorMessage = () => {
  const error = useSelector((state) => state.config.error);
  const navigate = useNavigate();

  useEffect(() => {
    if (!error) {
      navigate("/", { replace: true });
    }
  }, []);

  if (!error) {
    return <div className="h-auto bg-bkg"></div>;
  }
  return (
    <div className="bg-bkg pt-3 px-12">
      <Navbar />
      <div className="bg-bkg flex flex-col items-center justify-center h-auto p-4">
        <h3 className="font-semibold text-text-1 mb-4">{error.message}</h3>
        <img
          src={Error401}
          alt="Not Authorized"
          className="w-64 h-64 mb-8 object-cover"
        />
        <p className="text-text-1/60 text-center max-w-md">
          Please contact your administrator if you believe this is an error,
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
